<template>
<admin-template :title="currentJob ? currentJob.title : ''" :subtitle="subtitle" headerButton="Add Applicant"
  @onButtonClicked="onAddApplicant">
  <sidebar-modal :active.sync="showSidebar" :title="sidebarTitle"
    :button="labelButtonSubmit"
    :buttonEnabled="isButtonEnabled"
    :info="labelButtonInfo"
    :loading="sidebarLoading"
    :infoLoading="infoLoading"
    :destroyLoading="destroyLoading"
    :destructive="labelButtonDestroy"
    :error.sync="errorMessage"
    :message.sync="successMessage"
    v-on:action="onActionSubmit"
    v-on:destroy="rejectApplication"
    v-on:info="toggleInterviewModal(current)">
    <component v-bind:is="sidebarComponent"></component>
  </sidebar-modal>
  <banner :active.sync="bannerActive" :title="bannerTitle" :error="interviewError" :time=2000 />

  <dropdown-modal :active.sync="interviewModal" :title="this.$t('profile.keepTheProcess')" :noPadding="true">
    <messaging-bar class="topbar message-bar">
      <div class="info" v-if="interviewModal">
        <div class="user-image">
          <user-image :user="interviewUser" :state="userStatus" class="is-40x40 margin-zero" />
        </div>
        <div class="text-info">
          <a ><strong>{{ applicantName }}</strong></a>
                <span >Last active: {{ lastActive }}</span>
        </div>
      </div>
    </messaging-bar>
    <div class="interview-modal-content">
      <div>
      <textarea class="textarea" :placeholder="this.$t('profile.somethingAboutUrself')"
                v-model="interviewMessage" rows="8">
      </textarea>
      </div>
      <div class="interview-buttons" >
        <button @click="interviewHandler('skipping')" class="button  is-primary is-outlined is-fullwidth">{{this.$t('profile.skipMessage')}}</button>
        <div class="space"></div>
        <button @click="interviewHandler('message')" class="button is-primary is-fullwidth">{{ this.$t('profile.sendMessage')}}</button>
      </div>
    </div>
  </dropdown-modal>

  <dropdown-modal :active.sync="confirmationActive" :title="confirmationTitle" :autoClip="false">
    <p class="text">If you are sure you don't wish to move forward with this applicant, please hit the reject button. The applicant will receive an email to notify they haven't been shortlisted to move forward and to thank them for applying.</p>
    <div class="modal-buttons">
      <button class="button is-danger is-fullwidth" @click="confirmReject">REJECT APPLICANT</button>
    </div>
  </dropdown-modal>
  <dropdown-modal :active.sync="confirmationOffer" :title="confirmationTitle" :autoClip="false">
    <p class="text">
      If the applicant accepts your job offer of <b>${{parseFloat(currentOfferSalary).toLocaleString()}}</b>, your HireVibes invoice will cost the amount below.
    </p>
    <h1 class="title confirmationOffer__title">${{totalReward.toLocaleString()}}</h1>
    <h6 class="confirmationOffer__info">HVT {{(totalReward * tokenPrice).toLocaleString()}} @ ${{tokenPrice}} • <span class="confirmationOffer__info--link"  v-on:click.stop="onHandleBreakDown">{{viewBreakdown ? 'Hide': 'View'}} breakdown</span></h6>
    <div v-if="viewBreakdown">
      <div class="is-flex space-between confirmationOffer m-t-25">
        <h6>Cost Breakdown</h6>
        <h6>$</h6>
      </div>
      <div class="is-flex space-between">
        <div>Applicant reward</div>
        <div>{{userReward.toLocaleString()}}</div>
      </div>
      <div v-if="this.currentJob && this.currentJob.referrerId" class="is-flex space-between m-t-10">
        <div>Referrer reward</div>
        <div>{{referReward.toLocaleString()}}</div>
      </div>
      <div class="is-flex space-between m-t-10">
        <div>Applicant donation reward </div>
        <div>{{charityReward.toLocaleString()}}</div>
      </div>
      <div class="is-flex flex-start space-between m-t-10">
        <div>HireVibes fee </div>
        <div>{{dacReward.toLocaleString()}}</div>
      </div>
      <div class="is-flex space-between m-t-10">
        <div>Total</div>
        <div><strong>{{totalReward.toLocaleString()}}</strong></div>
      </div>
      <div class="is-flex space-between confirmationOffer m-t-16">
        <h6>Total cost</h6>
        <h6>HVT</h6>
      </div>
      <div class="is-flex space-between">
        <div>${{totalReward.toLocaleString()}} @ <span class="confirmationOffer__info--link">{{tokenPrice}}</span></div>
        <div>{{(totalReward * tokenPrice).toLocaleString()}}</div>
      </div>
    </div>
    <div class="modal-buttons">
      <button class="button is-primary is-fullwidth" @click="confirmOffer">Agree Terms</button>
    </div>
  </dropdown-modal>
  <list-nav
  :active.sync="activeItem"
  :keyword.sync="searchKeyword"
  :selectedItem.sync="filterBy"
  :showSearch = "false"
  :tabItems="['all', 'screening', 'interview', 'offered', 'hired', 'cancelled', 'rejected']"
  :selectItems = "[]"
  :suffixes="suffixes" />
  <div class="applications">
    <heading v-if="false">{{ activeItem }}</heading>
    <div class="applications-body">
      <cv-viewer cvUrl='' :isActive.sync="showCvViewer" />
      <div v-if="jobApplications.length > 0">
        <application-row-card  v-for="application in jobApplications"
          :key="application.id" :application=application
          @makeOffer="loadOfferForm(application)"
          @click="showApplication(application)"
        />
      </div>
      <empty-state v-else :title=" emptyTitle + ' Applicants'" icon="empty-state-eyes" ></empty-state>
    </div>
  </div>
</admin-template>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import AdminTemplate from './admin-sub'
import ApplicationDetail from '@/components/admin/applications/application-form'
import OfferDetail from '@/components/admin/applications/offer-detail'
import OfferForm from '@/components/applications/make-offer-form'
import SidebarModal from '@/components/sidebar-modal'
import ListNav from '@/components/general/list-nav'
import Heading from '@/components/general/heading'
import ApplicationRowCard from '../../components/applications/application-row-card.vue'
import DropdownModal from '@/components/dropdown-modal'
import Dropdown from '@/components/general/dropdown'
import EmptyState from '@/components/general/empty-state'
import RewardHelper from '@/helpers/reward'
import vSelect from 'vue-select'
import CvViewer from '@/components/general/cv-viewer'
import RegisterAndApply from '@/components/applications/register-and-apply'
import RegisterApplySuccess from '@/components/applications/register-apply-success'
import UserImage from '@/components/general/user-image'
import MessagingBar from '@/components/messaging/messaging-bar'
import Banner from '@/components/general/banner'
import Users from '@/api/users'
import moment from 'moment'
import Applications from '@/api/applications'

export default {
  components: {
    AdminTemplate,
    ApplicationDetail,
    OfferDetail,
    ApplicationRowCard,
    SidebarModal,
    ListNav,
    Heading,
    OfferForm,
    DropdownModal,
    Dropdown,
    vSelect,
    EmptyState,
    CvViewer,
    RegisterAndApply,
    RegisterApplySuccess,
    UserImage,
    MessagingBar,
    Banner
  },
  data () {
    return {
      activeItem: 'all',
      searchKeyword: '',
      filterBy: 'First Name',
      sidebarLoading: false,
      destroyLoading: false,
      infoLoading: false,
      showSidebar: false,
      sidebarComponent: 'ApplicationDetail',
      confirmationActive: false,
      confirmationOffer: false,
      confirmationTitle: 'Are you sure you want to reject this applicant?',
      pickedReason: 0,
      offerCurrency: null,
      errorMessage: null,
      successMessage: null,
      viewBreakdown: true,
      showCvViewer: false,
      interviewModal: false,
      selectedApplication: null,
      userStatus: 'offline',
      userLastActive: null,
      interviewError: null,
      bannerActive: false
    }
  },
  async mounted () {
    if (this.jobId !== null) {
      await this.getApplicationsForJob({
        jobId: this.jobId,
        state: ''
      })
      this.$store.commit('RegisterApply/setJobId', this.jobId)
      const currentApp = this.currentApplication
      if (currentApp !== null) {
        this.showApplication(currentApp)
      }
    }
  },
  computed: {
    subtitle () {
      const tally = this.currentTally
      const activeItem = this.activeItem
      switch (activeItem) {
        case 'all': return `All: ${tally.appliedCount || 0}`
        case 'screening': return `Screening: ${tally.pendingCount || 0}`
        case 'interview': return `Interviewing: ${tally.interviewingCount || 0}`
        case 'offered': return `Offered: ${tally.offeredCount || 0}`
        case 'hired': return `Hired: ${tally.hiredCount || 0}`
        case 'cancelled': return `Cancelled: ${tally.cancelledCount || 0}`
        case 'rejected': return `Rejected: ${tally.rejectedCount || 0}`
        default: return ''
      }
    },
    emptyTitle () {
      const tally = this.currentTally
      const activeItem = this.activeItem

      switch (activeItem) {
        case 'all': return `${tally.appliedCount || 0}`
        case 'screening': return `${tally.pendingCount || 0} Screening`
        case 'interview': return `${tally.interviewingCount || 0} Interviewing`
        case 'offered': return `${tally.offeredCount || 0} Offered`
        case 'hired': return `${tally.hiredCount || 0} Hired`
        case 'cancelled': return `${tally.cancelledCount || 0} Cancelled`
        case 'rejected': return `${tally.rejectedCount || 0} Rejected`
        default: return ''
      }
    },
    interviewMessage: {
      get () { return this.formInterviewMessage },
      set (value) { this.setInterviewMessage(value) }
    },
    interviewUser () {
      return {
        id: this.selectedApplication.id,
        firstName: this.selectedApplication.applicantFirstName,
        lastName: this.selectedApplication.applicantLastName,
        profilePictureUrl: this.selectedApplication.applicantProfilePictureUrl
      }
    },
    bannerTitle () {
      return this.interviewError ? this.interviewError : 'MESSAGE SENT'
    },
    applicantName () {
      return this.selectedApplication.applicantFirstName + ' ' + this.selectedApplication.applicantLastName
    },
    totalReward () {
      if (this.currentJob) {
        return RewardHelper.totalReward(this.currentOfferSalary, this.currentJob.rewardPercentage, this.currentJob.referrerId)
      }
      return 0
    },
    userReward () {
      if (this.currentJob) {
        return RewardHelper.user(this.totalReward, this.currentJob.rewardPercentage)
      }
      return 0
    },
    referReward () {
      if (this.currentJob) {
        return RewardHelper.referReward(this.totalReward, this.currentJob.rewardPercentage)
      }
      return 0
    },
    dacReward () {
      if (this.currentJob) {
        return RewardHelper.dac(this.totalReward, this.currentJob.rewardPercentage)
      }
      return 0
    },
    charityReward () {
      if (this.currentJob) {
        return RewardHelper.charity(this.totalReward, this.currentJob.rewardPercentage)
      }
      return 0
    },
    ...mapState('adminApplications', [
      'applications',
      'current',
      'currentJob',
      'jobApplications',
      'currentOfferSalary',
      'currentTally',
      'currentPrice'
    ]),
    ...mapState('adminApplications', {
      formInterviewMessage: 'interviewMessage'
    }),
    ...mapGetters('users', [
      'imageUrlForUser'
    ]),
    ...mapGetters('adminApplications', [
      'canMakeOffer',
      'hvtReward'
    ]),
    ...mapGetters('RegisterApply', ['isValid']),
    sidebarTitle () {
      switch (this.sidebarComponent) {
        case 'ApplicationDetail': return 'Application'
        case 'OfferDetail': return 'Offer Detail'
        case 'OfferForm': return 'Make Offer'
        case 'RegisterAndApply': return 'Add applicant'
        case 'RegisterApplySuccess': return 'Add applicant'
        default: return 'Application'
      }
    },
    suffixes () {
      const t = this.currentTally
      return [
        t.appliedCount ? t.appliedCount : 0,
        t.pendingCount ? t.pendingCount : 0,
        t.interviewingCount ? t.interviewingCount : 0,
        t.offeredCount ? t.offeredCount : 0,
        t.hiredCount ? t.hiredCount : 0,
        t.cancelledCount ? t.cancelledCount : 0,
        t.rejectedCount ? t.rejectedCount : 0
      ]
    },
    labelButtonSubmit () {
      switch (this.sidebarComponent) {
        case 'ApplicationDetail':
          switch (this.getstatus) {
            case 'interviewing': return 'Make Offer'
            default: return ''
          }
        case 'OfferForm':
          switch (this.getstatus) {
            case 'interviewing': return 'Confirm Offer'
            default: return ''
          }
        case 'RegisterAndApply':
          return 'Submit Applicant'
        default:
          return ''
      }
    },
    lastActive () {
      if (this.userStatus === 'active') {
        return 'Active Now'
      } else if (this.userStatus !== 'active' && this.userLastActive) {
        return moment(this.userLastActive).format('MMM DD, YYYY HH:SS a')
      }
      return ''
    },
    labelButtonInfo () {
      switch (this.sidebarComponent) {
        case 'RegisterAndApply':
          return ''
        case 'RegisterApplySuccess':
          return ''
        default:
          return this.getstatus === 'pending' ? 'Interview' : ''
      }
    },
    labelButtonDestroy () {
      switch (this.sidebarComponent) {
        case 'RegisterAndApply':
          return ''
        case 'ApplicationDetail':
          return this.getstatus === 'rejected' ? '' : 'Reject'
        default:
          return ''
      }
    },
    getstatus () {
      if (this.current) {
        return this.current.status
      }
      return ''
    },
    isLoading () {
      return this.infoLoading || this.destroyLoading || this.sidebarLoading
    },
    jobId () {
      return this.$route.params['id']
    },
    appId () {
      return this.$route.params['appId']
    },
    activeState () {
      switch (this.activeItem) {
        case 'screening': return 'pending'
        case 'interview': return 'interviewing'
        default: return this.activeItem
      }
    },
    isButtonEnabled () {
      switch (this.sidebarComponent) {
        case 'ApplicationDetail':
          return true
        case 'RegisterAndApply':
          return this.isValid
        default:
          return this.canMakeOffer
      }
    },
    reasons () {
      let reasons = []
      reasons[0] = {value: '1', label: 'Not suitable'}
      reasons[1] = {value: '2', label: 'Do not like'}
      reasons[2] = {value: '3', label: 'Weird guy'}
      reasons[3] = {value: '4', label: 'Overqualified'}
      reasons[4] = {value: '5', label: 'Underqualified'}
      reasons[5] = {value: '6', label: 'I do not know'}
      reasons[6] = {value: '7', label: 'Expensive'}
      return reasons
    },
    currentApplication () {
      if (!this.appId) {
        return null
      }
      const currentApp = this.jobApplications.filter((app) => {
        return app.id === this.appId
      })
      return currentApp[0]
    },
    tokenPrice () {
      return Number(this.currentPrice).toFixed(4)
    }
  },
  methods: {
    ...mapActions('adminApplications', {
      getAllApplications: 'getAll',
      getApplicationsWithState: 'getState',
      updateApplicationState: 'updateState',
      reject: 'reject',
      getApplicationsForJob: 'getApplicationsForJob',
      getReferralForApplicant: 'getReferralForApplicant',
      updateTally: 'updateTally',
      sendOffer: 'sendOffer'
    }),
    ...mapMutations('adminApplications', [
      'setCurrentApplication',
      'setCurrentApplicationOffer',
      'setCurrentReferral', 'setInterviewMessage'
    ]),
    ...mapActions('RegisterApply', [
      'addApplicant',
      'uploadResume'
    ]),
    async interviewHandler (type) {
      try {
        this.interviewError = null
        this.interviewModal = false
        const payload = { status: 'interviewing', skipping: type === 'skipping', message: type === 'skipping' ? '' : this.formInterviewMessage }
        await Applications.update(this.selectedApplication.id, {...payload})
        if (type !== 'skipping') {
          this.bannerActive = true
        }
        await this.getApplicationsForJob({ jobId: this.selectedApplication.jobId })
      } catch (e) {
        this.bannerActive = true
        this.interviewError = e.message
      }
    },
    async toggleInterviewModal (application) {
      try {
        this.showSidebar = false
        if (application) {
          const response = await Users.getStatus(application.id)
          this.selectedApplication = application
          this.userStatus = response.isConnected ? 'active' : 'offline'
          this.userLastActive = response.lastActive
          this.setInterviewMessage(`Hi ${application.applicantFirstName} ${application.applicantLastName}, \n\nWe have reviewed your application for the ${application.jobTitle} position and would like to arrange a phone / video interview with you to discuss the role and your qualifications further.\n\nPlease suggest some times to let us know when you're available, along with your preferred contact details.\n\nLooking forward to speaking with you!`)
        }
        if (this.interviewModal) {
          this.selectedApplication = null
          this.userStatus = 'offline'
          this.userLastActive = null
          this.setInterviewMessage('')
        }
        this.interviewModal = true
      } catch (e) {
        console.log('test pick error', e)
      }
    },
    hideSidebar () {
      const self = this
      setTimeout(function () {
        self.showSidebar = false
      }, 3000)
    },
    onAddApplicant () {
      this.showSidebar = true
      this.sidebarComponent = 'RegisterAndApply'
      this.$store.commit('RegisterApply/reset')
      this.$store.commit('RegisterApply/setResume', null)
    },
    openCvViewer (cvUrl) {
      this.showCvViewer = false
    },
    name (application) {
      const user = application.applicant || {}
      return [user.firstName, user.lastName].join(' ')
    },
    imageUrl (application) {
      const user = application.applicant || {}
      return this.imageUrlForUser(user)
    },
    onHandleBreakDown () {
      this.viewBreakdown = !this.viewBreakdown
    },
    async showApplication (application) {
      this.sidebarLoading = false
      if (application.status === 'offered') {
        this.sidebarComponent = 'OfferDetail'
        this.setCurrentApplicationOffer(application)
      } else {
        this.sidebarComponent = 'ApplicationDetail'
        this.setCurrentApplication(application)

        if (this.currentJob && this.currentJob.referrerId) {
          try {
            const referrer = await this.getReferralForApplicant(this.currentJob.referrerId)
            this.setCurrentReferral(referrer)
          } catch (e) {
            console.error(e)
          }
        }
      }
      this.showSidebar = true
    },
    loadOfferForm (application) {
      this.setCurrentApplication(application)
      this.showOfferForm()
    },
    showOfferForm () {
      this.sidebarComponent = 'OfferForm'
      this.showSidebar = true
      this.sidebarLoading = false
    },
    makeOffer () {
      this.sidebarLoading = true
      try {
        this.sendOffer()
        this.successMessage = 'Offer Submitted'
        this.updateJobs(this.activeItem)
        this.hideSidebar()
      } catch (error) {
        this.errorMessage = error.message
      }
      this.sidebarLoading = false
    },
    async confirmOffer () {
      this.confirmationOffer = false
      this.makeOffer()
    },
    async onActionSubmit () {
      if (this.isLoading) { return }
      this.sidebarLoading = true

      switch (this.sidebarComponent) {
        case 'RegisterAndApply':
          try {
            await this.addApplicant()
            await this.uploadResume()
            this.successMessage = 'Application Submitted'
            this.sidebarComponent = 'RegisterApplySuccess'
            this.getApplicationsForJob({ jobId: this.jobId })
          } catch (error) {
            this.errorMessage = error.message
          }
          this.sidebarLoading = false
          break
        case 'OfferForm':
          this.confirmationTitle = 'IF Offer Accepted'
          this.confirmationOffer = true
          break
        default:
          if (this.getstatus === 'interviewing') {
            this.showOfferForm()
            return
          }
          try {
            await this.updateApplicationState({ id: this.current.id, state: 'hired' })
            this.showSidebar = false
            this.updateJobs(this.activeItem)
          } catch (error) {
            this.errorMessage = error.message
          }
          this.sidebarLoading = false
      }
    },
    async rejectApplication () {
      if (this.isLoading || !this.current) { return }
      this.confirmationActive = true
    },
    async interviewApplication () {
      if (this.isLoading || !this.current) { return }
      this.infoLoading = true
      try {
        await this.updateApplicationState({ id: this.current.id, state: 'interviewing' })
        this.showSidebar = false
        this.updateJobs(this.activeItem)
      } catch (error) {
        this.errorMessage = error.message
      }
      this.infoLoading = false
    },
    updateJobs (activeItem) {
      switch (activeItem) {
        case 'all': {
          this.getApplicationsForJob({ jobId: this.jobId })
          break
        }
        default: {
          this.getApplicationsForJob({ jobId: this.jobId, state: this.activeState })
          break
        }
      }
    },
    async confirmReject () {
      this.destroyLoading = true
      try {
        await this.reject(this.pickedReason)
        this.updateJobs(this.activeItem)
        this.confirmationActive = false
        this.showSidebar = false
      } catch (error) {
        this.errorMessage = error.message
      }
      this.destroyLoading = false
    },
    selected (reason) {
      console.log(reason)
    }
  },
  watch: {
    activeItem (newValue) {
      this.updateJobs(newValue)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.confirmationOffer{
  h6 {
    color: $black;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: .5rem;
  }
  &__desription {
    font-size: 14px;
    line-height: 21px;
  }
  &__title {
    margin-bottom: 0px !important;
  }
  &__info {
    font-size: 12px;
    color: $black;
    font-weight: 500;
    text-align: center;
    margin-top: 4px;
    &--link {
      color: $brand-primary;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.dropdown {
  width: 100%
}

/deep/ .dropdown li a {
  padding: 0.7rem
}

/deep/ .dropdown .dropdown-toggle {
  width: 100%;
  height: 2.4rem;
  margin-bottom: 0.2em;
}

.preview {
  font-size: 9px;
}

.modal-buttons {
  margin-top: 1.5em;
}

.v-select {
  width: 100%;
  // margin-bottom: 0.7rem;
}

/deep/ .v-select li a {
  padding: 0.7rem
}

/deep/ .v-select .dropdown-toggle {
  width: 100%;
  height: 2.5rem;
  margin-bottom: 0.2em;
  border-color: #dbdbdb;
  background: #fff;
  font-size: 14px;
}

/deep/ .v-select .dropdown-toggle:hover {
  border-color: #b5b5b5;
}

/deep/ .v-select .open-indicator::before {
  content: "";
  z-index: 4;
  position: absolute;
  width: 0px;
  height: 0px;
  border-bottom: 6px solid black;
  border-right: 6px solid transparent;
  border-top: 6px solid transparent;
  border-left: 6px solid transparent;
  top: 18%;
  right: 1rem;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  transform-origin: bottom center;
  transition: all .15s cubic-bezier(1,-.115,.975,.855);
  transition-timing-function: cubic-bezier(1,-.115,.975,.855);
}

/deep/ .v-select .open-indicator::after {
  content: "";
  z-index: 4;
  position: absolute;
  width: 0px;
  height: 0px;
  border-top: 6px solid black;
  border-right: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid transparent;
  top: 52%;
  right: 1rem;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  transform-origin: top center;
  transition: all .15s cubic-bezier(1,-.115,.975,.855);
  transition-timing-function: cubic-bezier(1,-.115,.975,.855);
}

/deep/ .v-select.open .open-indicator::before {
  transform: rotate(180deg);
}

/deep/ .v-select.open .open-indicator::after {
  transform: rotate(180deg);
  opacity: 0.0;
}

/deep/ .v-select .clear {
  display: none;
}

 .title {
    font-size: 1.5rem;
    color: $black;
    font-weight: bold;
    text-align: center;
  }

</style>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.topbar {
  display: flex;
  a {
    color: black;
  }
}

.conversation-icon {
  position: fixed;
  top: 20px;
  left: 17px;
  z-index: 100;
}

.text-info {
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  span {
    color: #888;
  }
}

.info {
  display: flex;
  flex-direction: row;
}

.user-image {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.message-bar{
  height: auto !important; min-height: auto !important; background: #f9f9f9 !important;
}

.margin-zero{
  margin:0px !important;
}
.interview-modal-content{
  padding: 20px; background: #D6EFFA
}
.interview-buttons{
  margin-top: 20px; display: flex
}
.space{
  padding-left: 10px;padding-right: 10px
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/job-applications.vue